const axios = require('axios');

const ENV = process.env;

export default class AccountService {
  static register(user) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'post',
        url: ENV.api + '/users/',
        data: user,
      })
        .then(function success(successResponse) {
          ga('set', 'userId', successResponse.data.username);
          ga('send', 'event', 'Registration complete', 'Button Click', 'Registration complete');
          resolve(successResponse);
        })
        .catch(function error(errorResponse) {
          const errorField = Object.keys(errorResponse.response.data)[0];
          const errorMessage = errorResponse.response.data[errorField][0];
          reject(errorMessage);
        });
    });
  }

  static get() {
    const accessToken = localStorage.getItem('access_token');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
    return new Promise(function (resolve, reject) {
      axios({
        method: 'get',
        url: ENV.api + '/account/',
      })
        .then(function success(successResponse) {
          ga('set', 'userId', successResponse.data.username);
          resolve(successResponse);
        })
        .catch(function error(errorResponse) {
          reject(errorResponse.response.data.detail);
        });
    });
  }

  static update(account) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'PATCH',
        url: ENV.api + '/account/',
        data: account,
      })
        .then(function success(data) {
          resolve(data);
        })
        .catch(function error(errorMessage) {
          reject(errorMessage);
        });
    });
  }

  static validateEmail(key) {
    axios.get(ENV.api + '/validate-email?key=' + key)
      .then(function success(data) {
        return data;
      })
      .error(function error(data) {
        return data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/account.es6.js